// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./assets/styles/contact.scss
 ** module id = 7
 ** module chunks = 0
 **/